import { useEffect, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'

import styles from 'app/App.module.scss'
import { AnalyticsActionType } from 'types/analytics.type'

import HowSubhead from '../components/howSubhead/HowSubhead'
import MainBanner from '../components/mainBanner/MainBanner'
import MiniBanner from '../components/miniBanner/MiniBanner'
import { Video } from '../components/video/Video'
import { WhySubhead } from '../components/whySubhead/WhySubhead'
import { trackAnalytics } from '../utils/analytics'

export function App() {
  const [marketingFocused] = useState(true)

  // const { data: userAssignedRoles } = useUserAssignedRolesApi({
  //   params: { email: osContext.userDetails.email, id: osContext.userDetails.id },
  // })

  const src =
    'https://facade-api-tccc-dev-stage.playground-stage.coke.com/api/file-manager/v1/tenants/571f9aa5-bb8b-4f9f-8835-23e74b64e050/files/9c08bff1-96cc-4f99-9356-23141d8386e6/public-download'
  const handleAnalytics = (event: string) => {
    trackAnalytics({
      type: AnalyticsActionType.page,
      payload: event,
    })
  }

  useEffect(() => {
    handleAnalytics('pg_pv_ourwork')
  }, [])

  // user role will be available in future release, currently marketingFocused is set to true for testing purpose and to show mini banner in UI

  // useEffect(() => {
  //   if (userAssignedRoles) {
  //     setMarketingFocused(
  //       userAssignedRoles.some(
  //         role => role.role_name === 'tccc-marketing-manual' || role.role_name === 'tccc-marketing',
  //       ),
  //     )
  //   }
  // }, [userAssignedRoles])

  return (
    <BrowserRouter basename="/our-work">
      <div className={styles.container}>
        <MainBanner />
        <Video videoSrc={src} />
        <HowSubhead />
        <WhySubhead />
        {marketingFocused && (
          <section id="open-projects" className="mt-[80px]">
            {/* The things from work front like the open Projects/ Match & Thrive are not required in new PG3 and will be considered for future development*/}
            {/* <OpenProjectsWidget /> */}
          </section>
        )}
        <MiniBanner marketingFocused={marketingFocused} />
      </div>
    </BrowserRouter>
  )
}
